import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import { getStates, userSignup } from "../../api/server";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { attorneyBillingOptions } from "../../constants";
import SetupUserSelect from "./SetupUserSelect";
import "./set-up-user-account.css";

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  address1: Yup.string().required("Address Line 1 is required"),
  address2: Yup.string(),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zip: Yup.number().required("Zip Code is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Your Email is required"),
  username: Yup.string().required("Username is required"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase character"),
  billing: Yup.string().required("Billing is required"),
  phone: Yup.string().required("Phone Number is required"),
});

const SetUpAttorneyAccount = () => {
  const [updateLoading, setUpdateLoading] = useState(false);
  const [statesData, setStatesData] = useState([]);

  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (values, { resetForm }) => {
    setUpdateLoading(true);
    await userSignup(values)
      .then((res) => {
        toast.success(`An ${res.data.data.firstname } attorney account has been created`);;
        setUpdateLoading(false);
        resetForm();
      })
      .catch((error) => {
        setUpdateLoading(false);
        toast.error(error.response.data.error);
        console.error("Error updating user data:", error);
      });
  };

  useEffect(() => {
    const fetchStatesData = async () => {
      try {
        const response = await getStates();
        const data = response.data;
        setStatesData(data);
      } catch (error) {
        console.error("Error fetching states data:", error);
      }
    };
    fetchStatesData();
  }, []);

  return (
    <div>
      <div className="wrapper">
        <DashBoardSidebar />
        <div id="content" className="setup-user-page setup-attorney-page">
          <DashboardNavbar />
          <div className="">
            <header className="setup-user-heading">
              <h1>Set Up Attorney Account</h1>
              <span className="setup-user-heading-icon" aria-hidden="true"><i className="fa-solid fa-user-tie"></i></span>
            </header>

            <div>
              <Formik
                initialValues={{
                  type: "Atty",
                  firstName: "",
                  phone: "",
                  address1: "",
                  address2: "",
                  city: "",
                  state: "",
                  zip: "",
                  email: "",
                  username: "",
                  password: "",
                  billing: "",
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ errors }) => (
                  <Form className="setup-user-form">
                    <section className="setup-user-card" aria-labelledby="attorney-account-heading">
                      <div className="setup-section-heading">
                        <span className="setup-section-icon" aria-hidden="true"><i className="fa-solid fa-user-tie"></i></span>
                        <h2 id="attorney-account-heading">Attorney Account Info</h2>
                      </div>
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-attorney-firstName">
                            Attorney or Firm Name
                          </label>
                          <Field id="setup-attorney-firstName"
                            type="text"
                            name="firstName"
                            className="form-control"
                            placeholder="Enter attorney name"
                          />
                          <ErrorMessage
                            name="firstName"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-attorney-email">
                            Certificate Email Address
                          </label>
                          <Field id="setup-attorney-email"
                            type="text"
                            className="form-control"
                            name="email"
                            placeholder="Enter certificate email"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-attorney-username">Username</label>
                          <Field id="setup-attorney-username"
                            type="text"
                            className="form-control"
                            name="username"
                            placeholder="Enter Username"
                          />
                          <ErrorMessage
                            name="username"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-attorney-password">
                            Choose a Password
                          </label>
                          <div className="setup-password-control">
                          <Field id="setup-attorney-password"
                            type={showPass ? "text" : "password"}
                            className="form-control pe-5"
                            name="password"
                            placeholder="Enter your Password"
                          />
                          <button type="button" className="password-toggle" onClick={() => setShowPass(!showPass)} aria-label={showPass ? "Hide password" : "Show password"} aria-pressed={showPass}>
                            <i className={showPass ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true"></i>
                          </button>
                          </div>
                          <ErrorMessage
                            name="password"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>
                    </div>
                    </section>
                    <section className="setup-user-card" aria-labelledby="attorney-contact-heading">
                      <div className="setup-section-heading">
                        <span className="setup-section-icon" aria-hidden="true"><i className="fa-solid fa-address-book"></i></span>
                        <h2 id="attorney-contact-heading">Contact Info</h2>
                      </div>
                    <div className="row mt-60">
                      <div className="col-lg-6 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-attorney-address1">Address Line 1</label>
                          <Field id="setup-attorney-address1"
                            type="text"
                            className="form-control"
                            name="address1"
                            placeholder="Enter your address"
                          />
                          <ErrorMessage
                            name="address1"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-attorney-address2">Address Line 2</label>
                          <Field id="setup-attorney-address2"
                            type="text"
                            className="form-control"
                            name="address2"
                            placeholder="Enter your address"
                          />
                          <ErrorMessage
                            name="address2"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-attorney-city">City</label>
                          <Field id="setup-attorney-city"
                            type="text"
                            className="form-control"
                            name="city"
                            placeholder="Enter your city"
                          />
                          <ErrorMessage
                            name="city"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-attorney-state">State</label>
                          <Field name="state">
                            {({ field }) => (
                              <SetupUserSelect id="setup-attorney-state" disabled={!statesData.length}
                                {...field}
                                className="form-control"
                              >
                                {statesData.length > 0 && (
                                  <option value="">Select a State</option>
                                )}

                                {statesData.length > 0 ? (
                                  statesData.map((state, index) => (
                                    <option key={index} value={state.state}>
                                      {state.state}
                                    </option>
                                  ))
                                ) : (
                                  <option value="">Loading...</option>
                                )}
                              </SetupUserSelect>
                            )}
                          </Field>
                          <ErrorMessage
                            name="state"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-attorney-zip">Zip Code</label>
                          <Field id="setup-attorney-zip"
                            type="text"
                            className="form-control"
                            name="zip"
                            placeholder="Enter zip code"
                          />
                          <ErrorMessage
                            name="zip"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="input_wrap">
                          <label className="label-title" htmlFor="setup-attorney-phone">Phone Number</label>
                          <Field id="setup-attorney-phone"
                            type="text"
                            className="form-control"
                            name="phone"
                            placeholder="Enter your phone no."
                          />
                          <ErrorMessage
                            name="phone"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6">
                        <div className="input_wrap">
                          <label
                            className="label-title"
                            htmlFor="setup-attorney-billing"
                          >
                            Billing Options..
                          </label>
                          <Field name="billing">
                            {({ field }) => (
                              <SetupUserSelect {...field} id="setup-attorney-billing">
                                {attorneyBillingOptions.map((option) => (
                                  <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                              </SetupUserSelect>
                            )}
                          </Field>
                          <ErrorMessage
                            name="billing"
                            component="div"
                            className="error-message text-danger"
                          />
                        </div>
                      </div>
                    </div>
                    </section>
                    <div className="setup-user-actions">
                      <button
                        type="submit"
                        className="btn_brnd"
                        disabled={updateLoading}
                        onClick={() => {
                          if (Object.keys(errors).length > 0) {
                            toast.error("Form validation failed");
                          }
                        }}
                      >
                        {updateLoading ? (
                          <ThreeDots
                            height="20"
                            width="60"
                            radius="9"
                            color="#4fa94d"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{
                              display: "block",
                            }}
                            wrapperClassName="spinner"
                            visible={true}
                          />
                        ) : (
                          "Create"
                        )}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetUpAttorneyAccount;
